import BulkUploadDriverPolygonIdManager from "../../../views/BulkUploadDriverPolygonId";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkUploadDriverPolygonIdManagerRoutes = [
  {
    menuName: MenuNames.BULK_UPSERT_POLYGON,
    path: "/bulk-upload-driver-polygon-id",
    component: BulkUploadDriverPolygonIdManager,
    exact: true,
  },
];

export default BulkUploadDriverPolygonIdManagerRoutes;